import { render } from "./BriefcaseIcon.vue?vue&type=template&id=6a11b70e&scoped=true"
import script from "./BriefcaseIcon.vue?vue&type=script&lang=js"
export * from "./BriefcaseIcon.vue?vue&type=script&lang=js"

import "./BriefcaseIcon.vue?vue&type=style&index=0&id=6a11b70e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a11b70e"]])

export default __exports__